import {
  MimeTypeGroup,
  mimeTypeList,
  MimeType,
  MimeTypeToExtension,
  SupportedExtension,
} from "./mime-types";

// Deprecated
export type AcceptAttachFileType = {
  readonly name: string;
  readonly acceptFileTypeGroup: MimeTypeGroup | "*";
  readonly maxSize: number;
  readonly required: boolean;
};

// Deprecated
export class AcceptAttachFile {
  public readonly name: string;
  // Deprecated.
  public readonly acceptFileTypeGroup: MimeTypeGroup | "*";
  public readonly maxSize: number;
  public readonly required: boolean;

  // サーバー側にはまだ持っていないが、MimeTypeGroupから、最終的にこのプロパティの持ち方にする
  public readonly mimeTypes: MimeType[];

  public constructor(
    props: AcceptAttachFileType & {
      mimeTypes?: MimeType[];
    },
  ) {
    this.name = props.name;
    this.acceptFileTypeGroup = props.acceptFileTypeGroup;
    this.maxSize = props.maxSize;
    this.required = props.required;
    if (props.mimeTypes) {
      this.mimeTypes = props.mimeTypes;
      return;
    }
    switch (this.acceptFileTypeGroup) {
      case "*":
        this.mimeTypes = [...mimeTypeList];
        break;
      case "image":
        this.mimeTypes = ["image/png", "image/jpeg", "image/gif", "image/heif"];
        break;
      case "pdf":
        this.mimeTypes = ["application/pdf"];
        break;
      default:
        throw new Error(`"Unknown mimeTypeGroup ${this.acceptFileTypeGroup}`);
    }
  }

  mimeTypeList() {
    return this.acceptFileTypeGroup;
  }

  accept() {
    return this.mimeTypes!.join(",");
  }

  extensions() {
    let rtn: string[] = [];
    this.mimeTypes!.forEach((m) => {
      rtn = [...rtn, ...MimeTypeToExtension[m]];
    });
    return rtn;
  }

  label() {
    const images = this.mimeTypes
      .filter((m) => m.startsWith("image"))
      .map((m) => MimeTypeToExtension[m])
      .flat();
    let othersList = this.mimeTypes
      .filter((m) => !m.startsWith("image"))
      .map((m) => MimeTypeToExtension[m])
      .flat();
    const others = othersList
      .filter((m, i) => othersList.indexOf(m) === i)
      .join("、");
    const imagesLabels =
      images.length > 0 ? `画像（${images.join("、")}）` : undefined;
    return [imagesLabels, others].filter((f) => !!f).join("、");
  }

  validateFileType = (rawType: string, ext: string): boolean => {
    if (rawType !== "") {
      const type = rawType as MimeType;
      return this.mimeTypes.indexOf(type) !== -1;
    }
    const exts = this.mimeTypes.flatMap((m) => MimeTypeToExtension[m]);
    return exts.indexOf(ext.toLocaleLowerCase() as SupportedExtension) !== -1;
  };

  static newAnyFile(props: {
    index: number;
    name?: string;
    mimeTypes?: MimeType[];
    maxSize?: number;
  }) {
    return new AcceptAttachFile({
      name: props.name ? props.name : `${props.index}つ目のファイル`,
      // TODO:
      acceptFileTypeGroup: "*",
      maxSize: props.maxSize ? props.maxSize : 10,
      required: false,
      mimeTypes: props.mimeTypes,
    });
  }
}
